import { clsxm } from '@app/styles/clsxm';

// admin-emailbeheer blok B. Pill colours match the real UI kit tokens the mockup
// (admin-email-mockup_3.html) is built from: dev.trueqrcode.com/ui-kit?tab=Colors.
export type StatusPillVariant = 'ok' | 'warn' | 'bad' | 'info' | 'mut';

const VARIANT_STYLE: Record<StatusPillVariant, string> = {
  ok: 'bg-accept-light text-accept-text',
  warn: 'bg-[#fdf3cc] text-[#8a6d00]',
  bad: 'bg-[#fde2e2] text-[#b42d2d]',
  info: 'bg-[#e8eaff] text-[#4a45b8]',
  mut: 'bg-gray-100 text-gray-700',
};

export const StatusPill: React.FC<{ variant: StatusPillVariant; children: React.ReactNode }> = ({
  variant,
  children,
}) => (
  <span
    className={clsxm(
      'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11.5px] font-semibold',
      VARIANT_STYLE[variant]
    )}
  >
    {children}
  </span>
);
